import { DateFormatter } from "../date/DateFormatter";
import { DateParser } from "../date/DateParser";
import { DateRange } from "../date/DateRange";
import { ClassFlag } from "../dom-tools/ClassFlag";
import { ElementAttribute } from "../dom-tools/ElementAttribute";
import { DateFormater } from "../text/DateFormater";

export class DateHighlighter
{
  static readonly attribute = new ElementAttribute( "highlight-date" );
  static readonly highlightedFlag = new ElementAttribute( "highlighted-flag" );
  static readonly highlightTitle = new ElementAttribute( "highlight-title" );

  static applyOnDocument()
  {
    DateHighlighter.attribute.forEachInDoc( e => DateHighlighter.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {
    let elements = DateHighlighter.attribute.queryValueAllIn( e );

    

    let highlightedFlag = new ClassFlag( DateHighlighter.highlightedFlag.from( e, "highlighted" ) );

    let today = DateRange.now().start;

    let highlightTitle = DateHighlighter.highlightTitle.from( e, null );


    elements.forEach(
      ( el )=>
      {
        let value = el.innerHTML;
        let dateRange = DateParser.parseInternationalEnglish( value );

        if ( dateRange.durationInHours < 22 )
        {
          dateRange = dateRange.asWholeDayFromStart();
        }

        if ( ! dateRange.contains( today ) )
        {
          return;
        }

        if ( highlightTitle != null )
        {
          ElementAttribute.title.to( el, highlightTitle );
        }

        
        highlightedFlag.set( el );
      }
    );
  }
}